// One highlighted next step (U3): the card's recommended action, which `Space` presses. The
// server marks at most one (the model's choice, else the first primary action); this reads it
// back defensively and never picks a runtime-injected local action (dismiss, snooze, archive).
// A press goes through the same `press` as 1/2/3: a reversible action runs with Undo, an
// irreversible one (a send, a calendar write) only arms and needs its confirm press.
import type { CardAction } from "@shared/core";
import { recommendedIndex } from "@shared/startEasily";
import { isInjected } from "./actions";

export function recommendedAction(actions: readonly CardAction[]): CardAction | null {
  const configured = actions.filter((a) => !isInjected(a)).slice(0, 3);
  return configured[recommendedIndex(configured)] ?? null;
}
